import BackButtonComponent from "@components/ui/BackButton"
import Background from "@components/ui/Background"
import BigHeadingComponent from "@components/ui/BigHeading"
import Footer from "@components/ui/Footer"
import Main from "@components/ui/Main"
import {
  RoutePageContextProvider,
  resolveRoutePageState,
  useRoutePagePathname,
} from "@components/ui/route-page-context"
import SideMenu from "@components/ui/SideMenu"
import type { ReactNode } from "react"

type PageLayoutProps = {
  children: ReactNode
  page?: string
  title?: string
}

export function PageLayout({ children, page, title }: PageLayoutProps) {
  const pathname = useRoutePagePathname()
  const pageState = resolveRoutePageState({ page, pathname })

  const content = (
    <>
      {title ? <BigHeadingComponent>{title}</BigHeadingComponent> : null}
      {children}
    </>
  )

  return (
    <RoutePageContextProvider
      page={page}
      pathname={pathname}
    >
      <div className="relative flow-root min-h-[100dvh]">
        <SideMenu />
        <Main>
          {pageState.currentPage === "index" ? (
            content
          ) : (
            <div
              data-page={pageState.pageClass}
              className={`m-0 max-w-none p-0 ${
                ["calendar", "careers", "company", "work"].includes(pageState.pageClass)
                  ? "max-page:p-0"
                  : "max-page:px-[2rem] max-page:pt-[5rem] max-page:pb-[3rem]"
              }`}
            >
              {content}
            </div>
          )}
          {pageState.currentPage !== "index" ? <Footer /> : null}
        </Main>
        <Background />
      </div>
    </RoutePageContextProvider>
  )
}

export const BigHeading = BigHeadingComponent

export const BackButton = BackButtonComponent
